import {CA} from '../../analytics/Analytics'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {UIEndGameShareImage} from '../../ui_share_image/UIEndGameShareImage'
import {UIEndGameTitleImage} from '../../ui_share_image/UIEndGameTitleImage'
import {UIGameManager} from '../UIGameManager'
import {UIGameEndController} from './UIGameEndController'
import {ViewPopupShareImage} from '../../ui_popup/ViewPopupShareImage'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes'

export class UIGameEndShareButtonController {
    private readonly uiGameManager: UIGameManager
    private readonly gameEndController: UIGameEndController

    private readonly shareImage: UIEndGameShareImage
    private readonly titleImage?: UIEndGameTitleImage

    constructor(uiGameManager: UIGameManager, gameEndController: UIGameEndController) {
        this.uiGameManager = uiGameManager
        this.gameEndController = gameEndController

        this.shareImage = new UIEndGameShareImage(this.uiGameManager, this.gameEndController.endGameState)
        if(this.gameEndController.endGamePlayerState?.title != null) {
            this.titleImage = new UIEndGameTitleImage(this.uiGameManager, this.gameEndController.endGamePlayerState.title, this.gameEndController.endGameState)
        }
    }

    onClickShare() {
        const shareImagePopup = this.titleImage ? new ViewPopupShareImage(this.titleImage, this.shareImage, true) : new ViewPopupShareImage(this.shareImage)

        UIGameEndShareButtonController.sendShareButtonClickAnalytic()

        if(UIUtilsEjsVariables.isUserOnDiscord) {
            const shareAction = async(image: UIEndGameShareImage) => {
                const imageFile = await image.getImageFile()
                if(imageFile == undefined) return

                // eslint-disable-next-line @typescript-eslint/naming-convention
                const {DiscordInstance} = await import('../../../../web/scripts/discord/DiscordInstance.ts')
                void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareMoment, imageFile)

                UIGameEndShareButtonController.sendDiscordShareAnalytic()
            }

            shareImagePopup.setShareAction(shareAction)
        }
    }

    private static sendShareButtonClickAnalytic() {
        const endGameShareEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton,
        }
        void CA.sendAnalyticEventOnce(endGameShareEvent)
    }

    private static sendDiscordShareAnalytic() {
        const discordShareClickEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareDiscordButton,
        }
        void CA.sendAnalyticEventOnce(discordShareClickEvent)
    }
}
